var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.652,
    height: 31.613,
    viewBox: "0 0 26.652 31.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1712.174 -5166.693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.819-1H6.038A3.823,3.823,0,0,1,9.857,2.819V26.794a3.823,3.823,0,0,1-3.819,3.819H2.819A3.823,3.823,0,0,1-1,26.794V2.819A3.823,3.823,0,0,1,2.819-1ZM6.038,28.613a1.821,1.821,0,0,0,1.819-1.819V2.819A1.821,1.821,0,0,0,6.038,1H2.819A1.821,1.821,0,0,0,1,2.819V26.794a1.821,1.821,0,0,0,1.819,1.819Z",
    transform: "translate(1713.174 5167.693)",
    fill: "#0b5fa3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.819-1H6.038A3.823,3.823,0,0,1,9.857,2.819V26.794a3.823,3.823,0,0,1-3.819,3.819H2.819A3.823,3.823,0,0,1-1,26.794V2.819A3.823,3.823,0,0,1,2.819-1ZM6.038,28.613a1.821,1.821,0,0,0,1.819-1.819V2.819A1.821,1.821,0,0,0,6.038,1H2.819A1.821,1.821,0,0,0,1,2.819V26.794a1.821,1.821,0,0,0,1.819,1.819Z",
    transform: "translate(1728.969 5167.693)",
    fill: "#0b5fa3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.8430c2cf4041058416073313eccdd002.svg";
export { ForwardRef as ReactComponent };